var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "personal-use-selection" },
    [
      _vm.cart && _vm.availableItemsForPersonalUse.length
        ? [
            _vm.hasOrderItems
              ? [
                  _c(
                    "Modal",
                    {
                      ref: "personalUseSelectionModal",
                      attrs: {
                        disabled: false,
                        "trigger-class-list": _vm.triggerClassList,
                        initialOpen: _vm.initialOpen,
                      },
                    },
                    [
                      _c("template", { slot: "trigger" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.modalTriggerText) +
                            "\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("template", { slot: "content" }, [
                        _c(
                          "div",
                          { staticClass: "personal-use-modal" },
                          [
                            _c("h1", { staticClass: "h1" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "checkout.personalisation.personalUseModal.headline"
                                  )
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "checkout.personalisation.personalUseModal.info1"
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "checkout.personalisation.personalUseModal.info2"
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "checkout.personalisation.personalUseModal.info3"
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("hr"),
                            _vm._v(" "),
                            _vm._l(
                              _vm.availableItemsForPersonalUse,
                              function (additionalOrderItemConfiguration) {
                                return _c("personal-use-item", {
                                  key: additionalOrderItemConfiguration.id,
                                  attrs: {
                                    aoic: additionalOrderItemConfiguration,
                                    loading: _vm.submitting,
                                  },
                                  on: {
                                    selectPersonalUse: _vm.updatePersonalUSe,
                                  },
                                })
                              }
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "button button-inverted",
                                attrs: {
                                  disabled:
                                    _vm.submitting ||
                                    !_vm.hasChosenForAllTickets,
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    $event.preventDefault()
                                    return _vm.onSubmit.apply(null, arguments)
                                  },
                                },
                              },
                              [
                                _vm.hasSelectedForPersonalUse &&
                                _vm.hasChosenForAllTickets
                                  ? [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "checkout.personalisation.personalUseModal.buttonContinue"
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  : !_vm.hasChosenForAllTickets
                                  ? [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "checkout.personalisation.personalUseModal.buttonNotAllSelected"
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  : [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "checkout.personalisation.personalUseModal.buttonSkip"
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ],
                              ],
                              2
                            ),
                          ],
                          2
                        ),
                      ]),
                    ],
                    2
                  ),
                ]
              : [
                  _c(
                    "button",
                    {
                      staticClass: "button button-inverted",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.toCheckoutForm.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "checkout.personalisation.personalUseModal.buttonToCheckout"
                          )
                        )
                      ),
                    ]
                  ),
                ],
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }